import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1922d848"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "virus-trend-chart-wrap" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { buildLineAreaStyle, ECHARTS_LINE_COLOR, getAssignLineOption, withLineSeriesStyle } from '@/utils/echarts-option/line'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeFormat, TimeGranularity, TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { formatTimeStamp, getTimeRangeByEnum } from '@/utils/time'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import {  VirusTrendChartService,
  VirusTrendRes,
} from './virus-trend-chart.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'virus-trend-chart',
  setup(__props) {

const injector = useReflectiveInjector([VirusTrendChartService, ResizeService])
const service = injector.get(VirusTrendChartService)
const resizeService = injector.get(ResizeService)
const { t } = useI18n()

const isLoading = ref(false)
const timeRange = ref<TimeRange>(TimeRange.DAYS_30)
const timeRangeValue = ref<[number, number]>(getTimeRangeByEnum(TimeRange.DAYS_30))
const rawData = ref<VirusTrendRes>({
  time_points: [],
  untreated_counts: [],
})

const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const hasData = computed(() => {
  return rawData.value?.time_points?.length > 0
})

function createChart () {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
}

function getChartOption () {
  const timePoints = rawData.value?.time_points.map(v => formatTimeStamp(v, TimeFormat[timeRange.value]))
  const untreatedCounts = rawData.value?.untreated_counts || []
  const option = {
    grid: {
      left: 60,
      right: 40,
    },
    xAxis: {
      data: timePoints,
      triggerEvent: true,
      axisLabel: {
        hideOverlap: true
      },
    },
    series: [withLineSeriesStyle({
      name: t('safeProtectionModule.unhandledVirusCount'),
      data: untreatedCounts,
      type: 'line',
      areaStyle: buildLineAreaStyle(ECHARTS_LINE_COLOR.blue),
    }, ECHARTS_LINE_COLOR.blue)],
  }

  return getAssignLineOption(option, { unit: t('safeProtectionModule.countUnit') })
}

function renderChart () {
  if (!chartInstance) return
  chartInstance.setOption(getChartOption())
}

function initChart () {
  chartInstance?.dispose()
  createChart()
  renderChart()
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance?.resize()
})

function handleTimeRangeChange (value: TimeRange, timeRangeArray: [number, number]) {
  timeRange.value = value
  timeRangeValue.value = timeRangeArray
  loadData()
}

function loadData () {
  isLoading.value = true
  const [start_time, end_time] = timeRangeValue.value

  service.getVirusTrend({ start_time, end_time, granularity: TimeGranularity[timeRange.value] }).then((res) => {
    rawData.value = res
  }).finally(() => {
    isLoading.value = false
  })
}

watch(() => rawData.value, () => {
  if (!hasData.value) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

useEchartsThemeSync(renderChart)

onMounted(() => {
  loadData()
  if (hasData.value) {
    setTimeout(() => initChart(), 100)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance?.dispose()
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('safeProtectionModule.virusTrend'),
    class: "chart-card"
  }, {
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        onChange: handleTimeRangeChange
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart-container"
        }, null, 512), [
          [_vShow, hasData.value]
        ]),
        _withDirectives(_createVNode(EmptyData, {
          height: "100%",
          "bg-color": "transparent"
        }, null, 512), [
          [_vShow, !hasData.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})